/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */



window.addEventListener('load', function (event) {



  const modalLinks = document.querySelectorAll('#delivery-service-modal-link');
  const modals = document.querySelectorAll('#delivery-service-modal');

  if (modalLinks) {
    modalLinks.forEach((modalLink) => {
      modalLink.addEventListener('click', (e) => {
        e.preventDefault();
        const modalTarget = modalLink.getAttribute('data-modal-target');
        const modal = document.querySelector(modalTarget);

        if (modal) {
          modal.style.display = 'flex';
        }
      });

      modals.forEach((modal) => {
        const modalContent = modal.querySelector('#delivery-service-modal .modal-content');
        const modalClose = modal.querySelector('#delivery-service-modal .modal-close');

        modalClose.addEventListener('click', (e) => {
          e.preventDefault();
          modal.style.display = 'none';
        });

        modal.addEventListener('click', (e) => {
          if (e.target === modal) {
            modal.style.display = 'none';
          }
        });

        modalContent.addEventListener('click', (e) => {
          e.stopPropagation();
        });

        document.addEventListener('click', (e) => {
          if (modal.style.display === 'flex' && !modalContent.contains(e.target) && !modalLink.contains(e.target)) {
            modal.style.display = 'none';
          }
        });
      });
    });
  }



  const announcementBarWrapper = document.querySelector(".AnnouncementBar__SlideWrapper");
  if (announcementBarWrapper) {
    const flickityAnnouncementBarWrapper = new window.Flickity(announcementBarWrapper, {
      "prevNextButtons": false,
      "wrapAround": false,
      "dragThreshold": 15,
      "pauseAutoPlayOnHover": false,
      "autoPlay": 5000,
      "pageDots": false
    });
  }


  document.querySelectorAll("#header-locale-popover .Popover__Content a").forEach(element => {
    element.addEventListener("click", function (e) {
      e.preventDefault();
      const countryCode = element.dataset.countryCode;
      const langCode = element.dataset.lang;
      document.querySelector(".Header__SecondaryNav input[name='country_code']").value = countryCode;
      document.querySelector(".Header__SecondaryNav input[name='locale_code']").value = langCode;
      //document.querySelector(".Header__SecondaryNav #localization_form").submit();
    });
  })


  const countrySwitcher = Array.from(document.querySelectorAll("[data-country-code]"));
  countrySwitcher.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      const countryCode = e.currentTarget.dataset.countryCode
      const langCode = e.currentTarget.dataset.lang
      document.querySelector("#localization_form [name='country_code']").value = countryCode;
      document.querySelector("#localization_form [name='locale_code']").value = langCode;
      document.querySelector("#localization_form").submit();
    });
  });

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail.variant;
    if (variant.unit_price) {
      const productMeasurement = document.querySelector("#productMeasurement");
      productMeasurement.innerHTML = Shopify.formatMoney(variant.unit_price);
    }
  });

  const shippingProgressBar = document.querySelector("#Shipping_ProgressBar");
  const shippingProgressBarStatus = document.querySelector("#Shipping_ProgressBarStatus");

  if (shippingProgressBar) {
    var currentDate = new Date();
    if (currentDate.getDay() == 7) {
      shippingProgressBar.style.width = `15%`;
    } else if (currentDate.getDay() == 6) {
      shippingProgressBar.style.width = `50%`;
      shippingProgressBarStatus.innerText = "Nur solange der Vorrat reicht!"
      shippingProgressBar.style.background = `orange`;
    } else {
      //shippingProgressBar.style.width = `80%`;
      // shippingProgressBar.style.background = `green`;
      // shippingProgressBarStatus.innerText = "Nur solange der Vorrat reicht!"
    }
  }

  const quickAddItems = document.querySelectorAll(".ProductItem-QuickAdd");
  quickAddItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('theme:loading:start'))
      const variantId = e.currentTarget.dataset.variantId;
      let formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      }

      fetch(window.theme.localeRootUrl + '/cart/add.js', {
        body: JSON.stringify(formData),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'))
        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: 1,
            },
          })
        )
      })


    });
  });


  var atcKcalPage = document.querySelectorAll(".Button-AddToCard-Round");
  atcKcalPage.forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      var variantId = e.currentTarget.dataset.variantId;
      let formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      };


      fetch(window.theme.localeRootUrl + '/cart/add.js', {
        body: JSON.stringify(formData),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
      }).then(() => {
        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: variantId,
              quantity: 1,
            },
          })
        );
      })
    });
  });


  var target = document.querySelector('.ProductForm');

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {

      function rcShowHide() {
        if (document.getElementsByClassName('rc_widget__option__input--subsave')[0].checked) {
          document.getElementsByClassName('rc_popup')[0].style.display = 'block';
        } else {
          document.getElementsByClassName('rc_popup')[0].style.display = 'none';
        }
      }
      rcShowHide();
      var el = document.getElementsByClassName('rc-radio__input');
      for (var i = 0; i < el.length; i++) {
        el[i].addEventListener('click', rcShowHide);
      }

    });
  });
  var config = { attributes: false, childList: true, characterData: false };
  if (target) {
    observer.observe(target, config);
  }
});


function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

var anchors = document.querySelectorAll('.toggleMobile')
for (var i = 0; i < anchors.length; i++) {
  var current = anchors[i]
  current.addEventListener('click', function (e) {
    e.stopPropagation()
    e.preventDefault()
    console.log('toggle')
    e.target.parentNode.classList.toggle('visible')
    // Your click handler
  })
}

; (function () {
  function scrollToElement(event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== '') {
      // Prevent default anchor click behavior
      event.preventDefault()

      // Store hash
      var hash = this.hash

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {
          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash
        }
      )
    } // End if
  }

  //Add to cart
  function add_to_cart_collection(event) {
    event.preventDefault() // Prevent form to be submitted

    var addToCartButton = event.target

    // First, we switch the status of the button
    addToCartButton.setAttribute('disabled', 'disabled')
    document.dispatchEvent(new CustomEvent('theme:loading:start'))

    // Then we add the product in Ajax
    var formElement = event.target.parentElement

    let formData = {
      items: [
        {
          id: formElement[0].value,
          quantity: 1,
        },
      ],
    }

    fetch(window.theme.localeRootUrl + '/cart/add.js', {
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'))
      if (response.ok) {
        addToCartButton.removeAttribute('disabled')
        // We simply trigger an event so the mini-cart can re-render
        addToCartButton.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: formElement[0].value,
              quantity: 1,
            },
          })
        )
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span')
          errorMessageElement.className =
            'ProductForm__Error Alert Alert--error'
          errorMessageElement.innerHTML = content['description']
          addToCartButton.removeAttribute('disabled')
          addToCartButton.insertAdjacentElement('afterend', errorMessageElement)
          setTimeout(function () {
            errorMessageElement.remove()
          }, 2500)
        })
      }
    })
  }

  var productListItems = document.querySelectorAll(
    '.ProductItem .ProductForm__AddToCart '
  )
  for (var i = 0; i < productListItems.length; i++) {
    productListItems[i].addEventListener('click', add_to_cart_collection)
  }

  var productListWrapper = document.getElementsByClassName('CollectionMain')
  var filterButtons = document.querySelectorAll('.Filter--Button')
  for (var i = 0; i < filterButtons.length; i++) {
    var current = filterButtons[i]
    /**
     * current.addEventListener('click', function (e) {
      e.stopPropagation()
      e.preventDefault()
      var filterItem = e.target.dataset.filterItem
      console.log(filterItem)
      productListWrapper[0].classList.remove(
        'filter-unsere-gerichte',
        'filter-bundles',
        'filter-snacks'
      )
      if (filterItem) {
        productListWrapper[0].classList.add(filterItem)
      }
    })
    **/
    current.addEventListener('click', scrollToElement)
  }

  var filterBar = document.getElementById('filter-bar-mobile')
  if (filterBar) {
    filterBar.addEventListener('change', function (e) {
      e.stopPropagation()
      e.preventDefault()

      var filterItem = e.target.value
      productListWrapper[0].classList.remove(
        'filter-unsere-gerichte',
        'filter-bundles',
        'filter-snacks'
      )
      if (filterItem) {
        productListWrapper[0].classList.add(filterItem)
      }
    })
  }

  if (document.getElementsByClassName('accordion')) {
    var acc = document.getElementsByClassName('accordion')
    var i

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function () {
        this.classList.toggle('active')
        var panel = this.nextElementSibling
        if (panel.style.display === 'block') {
          panel.style.display = 'none'
        } else {
          panel.style.display = 'block'
        }
      })
    }
  }

  const collFilters = document.querySelectorAll('.rezepte-filter');

  if (collFilters.length > 0) {
    collFilters.forEach((collFilter) => {
      collFilter.addEventListener('change', function () {
        var newTags = [];
        collFilters.forEach((collFilter) => {
          for (var i = 0; i <= collFilter.length - 1; i++) {
            if (collFilter[i].selected == true && collFilter[i].value != "") {
              newTags.push(collFilter[i].value);
            }
          }
        });

        if (newTags.length) {
          var query = newTags.join('+');
          window.location.href = '/blogs/rezepte/tagged/' + query;
        }
      });
    });
  }


})()

if (document.getElementsByClassName('ProductList').length) {
  var flickityInstanceProduct = Flickity.data(
    document.getElementsByClassName('ProductList')[0]
  )
  if (flickityInstanceProduct) {
    if (window.innerWidth > 800) {
      flickityInstanceProduct.unbindDrag()
    }
    flickityInstanceProduct.on('select', function (index) {
      var url = flickityInstanceProduct.selectedElement.querySelector(
        'a.ProductItem__ImageWrapper'
      ).href
      var productInformations = document.querySelector(
        '#productInformationsBtn'
      )
      productInformations.href = url
    })
  }
}

var AdvantagesCarousel = document.getElementsByClassName('Advantages-Carousel')
if (
  AdvantagesCarousel &&
  AdvantagesCarousel.length &&
  window.innerWidth < 1007
) {
  var flickityInstanceAdvantagesCarousel = new window.Flickity(
    AdvantagesCarousel[0],
    JSON.parse(AdvantagesCarousel[0].dataset.flickityConfig)
  )
}

var RatesCarousel = document.getElementsByClassName('Rates-Carousel')
if (RatesCarousel && RatesCarousel.length) {
  var flickityInstance = new window.Flickity(
    RatesCarousel[0],
    JSON.parse(RatesCarousel[0].dataset.flickityConfig)
  )

  if (window.innerWidth > 1007) {
    flickityInstance.unbindDrag()
  }

  document
    .getElementById('review-prev-btn')
    .addEventListener('click', function () {
      flickityInstance.previous()
    })

  document
    .getElementById('review-next-btn')
    .addEventListener('click', function () {
      flickityInstance.next()
    })
}

if (document.querySelector('.subscription-wrapper')) {
  var elements = document.getElementsByClassName('product-quantity-selector')
  var price = 0
  var items = {}

  for (let element of elements) {
    let currentNumber = element.querySelector(
      '.QuantitySelector__CurrentQuantity'
    ).value
    let buttons = element.getElementsByClassName('QuantitySelector__Button')
    let product_id = element.getAttribute('data-sku')
    let product_price = element.getAttribute('data-price')
    let product_normal_price = element.getAttribute('data-normal-price')
    let product_selling_plan = element.getAttribute('data-selling-plan')

    for (let button of buttons) {
      button.addEventListener('click', (e) => {
        var action = e.target.getAttribute('data-action')
        if (action == 'increase-quantity') {
          currentNumber++
        } else {
          currentNumber = Math.max(currentNumber - 1, 0)
        }

        items[product_id] = {
          currentNumber: currentNumber,
          product_price: product_price,
          product_normal_price: product_normal_price,
          product_selling_plan

        }
        element.querySelector(
          '.QuantitySelector__CurrentQuantity'
        ).value = currentNumber
        price = Object.values(items).reduce(
          (pv, cv) => pv + cv.currentNumber * cv.product_price,
          0
        )
        price_normal = Object.values(items).reduce(
          (pv, cv) => pv + cv.currentNumber * cv.product_normal_price,
          0
        )

        document.querySelector('#product_price').textContent =
          (price / 100).toFixed(2) + ' €'
        document.querySelector('#product_price_normal').textContent =
          (price_normal / 100).toFixed(2) + ' €'
      })
    }
  }

  Shopify.queue = []

  function addItemToCart2(
    variant_id,
    quantity,
    shipping_interval_frequency,
    shipping_interval_unit_type,
    subscription_id
  ) {
    data = {
      quantity: quantity,
      id: variant_id,
      'properties[shipping_interval_frequency]': shipping_interval_frequency,
      'properties[shipping_interval_unit_type]': shipping_interval_unit_type,
      'properties[subscription_id]': subscription_id,
    }

    var r = new XMLHttpRequest()
    r.open('POST', '/cart/add.js', true)
    r.setRequestHeader('Content-Type', 'application/json')
    r.onreadystatechange = function () {
      if (r.readyState != 4 || r.status != 200) return
      document.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: variant_id,
            quantity: quantity,
          },
        })
      )
    }
    r.send(JSON.stringify(data))

    //window.location = '/checkout';
  }

  function addItemToCart(data) {
    var r = new XMLHttpRequest()
    r.open('POST', '/cart/add.js', true)
    r.setRequestHeader('Content-Type', 'application/json')
    r.onreadystatechange = function () {
      if (r.readyState != 4 || r.status != 200) return
      Shopify.moveAlong()
    }

    r.send(JSON.stringify(data))

    //window.location = '/checkout';
  }

  Shopify.queue = []

  Shopify.moveAlong = function () {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
      var request = Shopify.queue.shift()
      addItemToCart(request)
    }
    // If the queue is empty, we will redirect to the cart page.
    else {
      $ = window.jQuery172

      var paramCart =
        '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)') || 0)[2]
      jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'text',
        success: function (data) {
          if (data.indexOf('subscription_id') > -1) {
            var paramDomain = 'myshopify_domain=' + shopinfos.domain
            try {
              var paramLinker = '&' + ga.getAll()[0].get('linkerParam')
            } catch (err) {
              var paramLinker = ''
            }
            var paramCustomer =
              '&customer_id=' +
              shopinfos.customer_id +
              '&customer_email=' +
              shopinfos.customer_email
            window.location =
              'https://checkout.rechargeapps.com/r/checkout?' +
              paramDomain +
              paramCart +
              paramLinker +
              paramCustomer
          } else {
            window.location = '/checkout'
          }
        },
      })
    }
  }

  if (document.querySelector('#add-to-cart-button')) {
    function add_to_cart_abo() {
      if (!Object.keys(items).length) {
        return
      }
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      var cartItems = [];
      Object.keys(items).forEach((elem) => {
        var value = items[elem]

        cartItems.push({
          quantity: value.currentNumber,
          id: elem,
          selling_plan: value.product_selling_plan
        })

      })


      fetch('/cart/add.js', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: cartItems }),
      }).then(res => res.json())
        .then(res => {
          console.log(res);
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          res.items.forEach(item => {
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: item.variant_id,
                quantity: item.quantity,
              },
            }));

          })
        });


      //var request = Shopify.queue.shift()
      //addItemToCart(request)
    }

    document
      .querySelector('#add-to-cart-button')
      .addEventListener('click', add_to_cart_abo)
    document
      .querySelector('#add-to-cart-button-sticky')
      .addEventListener('click', add_to_cart_abo)
  }

  MyFormatter = function () { }
}



// UPSell


function add_event_listener_to_upsell() {
  if (!document.querySelector("#upsell-atc")) return;
  document.querySelector("#upsell-atc").addEventListener('click', function (e) {
    e.preventDefault();
    var data = {
      quantity: e.currentTarget.dataset.quantity,
      id: e.currentTarget.dataset.variant
    };

    var r = new XMLHttpRequest()
    r.open('POST', '/cart/add.js', true)
    r.setRequestHeader('Content-Type', 'application/json')
    r.onreadystatechange = function () {
      if (r.readyState != 4 || r.status != 200) return
      document.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: data.variant_id,
            quantity: parseInt(data.quantity),
          },
        })
      )
    }
    r.send(JSON.stringify({ items: [data] }))

  });
}
add_event_listener_to_upsell();

document.addEventListener('product:added', add_event_listener_to_upsell);


var observer = new MutationObserver(function (mutations) {
  add_event_listener_to_upsell();
});

// Konfiguration des Observers: alles melden - Änderungen an Daten, Kindelementen und Attributen
var config = { attributes: false, childList: true, characterData: false };

// eigentliche Observierung starten und Zielnode und Konfiguration übergeben
observer.observe(document.querySelector("#sidebar-cart"), config);

//FFMI-Rechner
if (document.getElementById("submit-fmi")) {
  var submitButton = document.querySelector("#submit-fmi");
  submitButton.addEventListener('click', function () {
    var results = {};

    var elements = document.querySelectorAll('.ffmirechner-wrapper input')
    for (var i = 0, length = elements.length; i < length; i++) {
      var elem = elements[i]
      results[elem.name] = parseInt(elem.value);
    }

    var magermasse = results.gewicht * (1 - results.kfa / 100);

    var ffmi = (magermasse / ((results.groesse / 100) * (results.groesse / 100))) + 6.1 * (1.8 - (results.groesse / 100))
    console.log(ffmi);
    document.querySelector('.kcal-result').removeAttribute('style')
    document.querySelector('.kcal-result').scrollIntoView(false)
    document.getElementById('submit-ffmi-evaluation')
      .addEventListener('click', function () {

        var email = document.getElementById("kcal-email").value;
        if (email && validateEmail(email)) {

          var kcalInput = document.querySelector("#k_id_ffmi");
          kcalInput.value = ffmi.toFixed(1);

          var emailInput = document.querySelector("#k_id_email");
          emailInput.value = email;

          var form = document.querySelector(".klaviyo_submit_button");
          setTimeout(function () { form.click(); }, 300);



          document.querySelector(".email-input .Alert").style.display = 'block';
          document.querySelector(".email-input #kcal-email").style.display = 'none';
          document.querySelector(".email-input #submit-ffmi-evaluation").style.display = 'none';
        }
      });
  })

}



//Kalorienrechner
if (document.getElementById('submit-kalorienrechner') != null) {
  function toggleAvtice(selector) {
    var nodeListZiele = document.querySelectorAll(selector)
    for (var i = 0, length = nodeListZiele.length; i < length; i++) {
      var elem = nodeListZiele[i]
      elem.addEventListener('click', function (e) {
        e.preventDefault()
        var nodeListZiele = document.querySelectorAll(selector)
        for (var i = 0, length = nodeListZiele.length; i < length; i++) {
          var elem = nodeListZiele[i]
          elem.classList.remove('active')
        }
        e.currentTarget.classList.add('active')
      })
    }
  }

  toggleAvtice('.auswahl_ziel a')
  toggleAvtice('.gender .select_gender')
  var sliders = []

  var nodeList = document.querySelectorAll('.range')
  for (var i = 0, length = nodeList.length; i < length; i++) {
    var elem = nodeList[i]
    var values = JSON.parse(elem.getAttribute('data-values'))

    noUiSlider.create(elem, {
      connect: true,
      start: 0,
      step: 1,
      range: {
        min: [0],
        max: [values.length - 1],
      },
      pips: {
        mode: 'steps',
        density: 100,
        format: {
          to: function (value) {
            value = Math.round(value)
            if (value < 0) {
              value = 0
            }
            if (value >= values.length) {
              value = values.length - 1
            }
            return values[value]
          },

          from: function (value) {
            let result = values.indexOf(value)
            return result == -1 ? 0 : result
          },
        },
      },
    })

    sliders.push(elem)
  }

  var range = document.getElementById('range')

  function animateValue(element, start, end, duration) {
    var range = end - start
    var current = start
    var increment = end > start ? 1 : -1
    var stepTime = Math.abs(Math.floor(1 / range))
    var obj = element
    var timer = setInterval(function () {
      current += increment
      obj.innerHTML = current
      if (current == end) {
        clearInterval(timer)
      }
    }, 0.0003)
  }

  document
    .getElementById('submit-kalorienrechner')
    .addEventListener('click', function () {
      var results = {};
      console.log(results);

      var elements = document.querySelectorAll('.kalorienrechner-wrapper input')
      for (var i = 0, length = elements.length; i < length; i++) {
        var elem = elements[i]
        results[elem.name] = elem.value
      }

      for (let i = 0; i < sliders.length; i++) {
        var elem = sliders[i]
        var selected_value = parseInt(elem.noUiSlider.get())
        results[elem.getAttribute('name')] = selected_value
      }

      results.target = document
        .querySelector('.auswahl_ziel .active')
        .getAttribute('data-target')
      results.gender = document
        .querySelector('.gender .active')
        .getAttribute('data-gender')

      var kcal = calcKcla(results)
      console.log(kcal);
      if (kcal) {
        document.querySelector('.kcal-result').removeAttribute('style')
        document.querySelector('.kcal-result').scrollIntoView(false)

        document.getElementById('email_signup')
          .addEventListener('submit', function (e) {
            return false;

          });

        document.getElementById('email_signup')
          .addEventListener('submit', function (e) {
            //e.preventDefault();
          });

        document.getElementById('submit-kcal-evaluation')
          .addEventListener('click', function () {



            var email = document.getElementById("kcal-email").value;
            if (email && validateEmail(email)) {

              var interesseInput = document.querySelector("#k_id_interesse");
              interesseInput.value = results.target;

              var genderInput = document.querySelector("#k_id_geschlecht");
              genderInput.value = results.gender;

              var kcalInput = document.querySelector("#k_id_kcal");
              kcalInput.value = kcal;

              var emailInput = document.querySelector("#k_id_email");
              emailInput.value = email;

              var form = document.querySelector(".klaviyo_submit_button");
              setTimeout(function () { form.click(); }, 300);



              document.querySelector(".email-input .Alert").style.display = 'block';
              document.querySelector(".email-input #kcal-email").style.display = 'none';
              document.querySelector(".email-input #submit-kcal-evaluation").style.display = 'none';
            } else {
            }
          });
      }
    })

  function calcKcla(data) {
    var check_req_index = [
      'target',
      'gender',
      'age',
      'gewicht',
      'groesse',
      'aktivitaetsniveau',
      'schlafdauer',
      'zustand',
    ]

    for (index of check_req_index) {
      if (!data.hasOwnProperty(index) || (!data[index] && data[index] != 0)) return false
    }

    var mapping_arbeit = [
      1.35,
      1.6,
      1.8,
      2.1
    ]

    var schlaf = [
      5,
      6,
      7,
      8,
      9,
      10,
      11,
    ]

    var grundumsatz = 0
    if (data['gender'] == 'w') {
      var mapping_zustand = [
        0.95,
        0.9,
        0.85,
        0.8,
      ]

      grundumsatz =
        655.1 +
        9.6 * data['gewicht'] +
        1.8 * data['groesse'] -
        4.7 * data['age']
      grundumsatz = grundumsatz * mapping_zustand[data['zustand']]
    } else {
      mapping_zustand = [
        1.05,
        1.0,
        0.95,
        0.9,
      ]

      grundumsatz =
        66.47 + 13.7 * data['gewicht'] + 5 * data['groesse'] - 6.8 * data['age']
      grundumsatz = grundumsatz * mapping_zustand[data['zustand']]
    }

    var leistungsumsatz_faktor =
      schlaf[data['schlafdauer']] * 0.95 +
      8 * mapping_arbeit[data['aktivitaetsniveau']] +
      (24 - schlaf[data['schlafdauer']] - 8) * 1.45 +
      parseFloat(data['sportaktivitaet'])

    var kcal = (leistungsumsatz_faktor / 24) * grundumsatz

    if (data['target'] == 'muskelaufbau') {
      kcal = kcal + 200
    } else if (data['target'] == 'abnehmen') {
      kcal = kcal - 400
    }

    kcal = Math.ceil(kcal)

    return kcal
  }
}

var isOutOfViewport = function (elem) {
  // Get element's bounding
  var bounding = elem.getBoundingClientRect()

  // Check if it's out of the viewport on each side
  var out = {}
  out.top = bounding.top < 0
  out.left = bounding.left < 0
  out.bottom =
    bounding.bottom >
    (window.innerHeight || document.documentElement.clientHeight)
  out.right =
    bounding.right > (window.innerWidth || document.documentElement.clientWidth)
  out.any = out.top || out.left || out.bottom || out.right
  out.all = out.top && out.left && out.bottom && out.right

  return out
}

// Erst prüfen, ob position: sticky nicht sowieso schon unterstützt wird
let header = document.getElementById('stickyATC')
if (header) {
  //let mainBTN = document.getElementById("mainATC");
  //let mainBTN = document.querySelector(".ProductForm__AddToCart:not(.ProductForm__AddToCart_Sticky)");// document.getElementById("mainATC");
  let positionSticky = window
    .getComputedStyle(header)
    .getPropertyValue('position')

  window.addEventListener('scroll', function (event) {
    let mainBTN = document.querySelector(
      '.ProductForm__AddToCart:not(.ProductForm__AddToCart_Sticky)'
    ) // document.getElementById("mainATC");

    if (isOutOfViewport(mainBTN).any) {
      header.classList.add('sticky')
    } else {
      header.classList.remove('sticky')
    }
  })
}

var gcd = function (a, b) {
  if (b < 0.0000001) return a;                // Since there is a limited precision we need to limit the value.

  return gcd(b, Math.floor(a % b));           // Discard any fractions due to limitations in precision.
};



if (document.getElementById('IngredientsCalculator--Select')) {
  document.getElementById('IngredientsCalculator--Select').addEventListener('change', function (e) {
    var count = e.target.value;
    var elements = document.querySelectorAll(".IngredientsCalculator--Table-Row[data-countable]");
    elements.forEach(function (element) {
      var value = element.dataset.value;
      var unit = element.dataset.unit;
      if (value.includes("/")) {
        var numbers = value.split("/");
        var fraction = (parseInt(numbers[0]) / parseInt(numbers[1])) * count;
        var len = fraction.toString().length - 2;

        var denominator = Math.pow(10, len);
        var numerator = fraction * denominator;

        var divisor = gcd(numerator, denominator);    // Should be 5

        numerator /= divisor;                         // Should be 687
        denominator /= divisor;                       // Should be 2000
        if (denominator == numerator) {
          element.querySelector(".IngredientsCalculator--Table-Value").innerText = `${Math.floor(numerator)} ${unit}`;
        } else {
          element.querySelector(".IngredientsCalculator--Table-Value").innerText = `${Math.floor(numerator)}/${Math.floor(denominator)} ${unit}`;
        }
      } else {
        element.querySelector(".IngredientsCalculator--Table-Value").innerText = `${value * count} ${unit}`;

      }
      console.log(`${value} ${unit}`);
    });
  });
}



function initPorductBars() {
  var productBars = document.querySelectorAll(".SingleNutritional");
  if (productBars) {
    var target = "m";
    var callback = (entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          var barStatus = entry.target.querySelector(".SingleNutritional--BarStatus");
          var percent = (target == "m") ? barStatus.dataset.mPercent : barStatus.dataset.wPercent;
          barStatus.style.width = `${percent}%`
        }
      });
    }
    let options = {
      root: document.querySelector('#scrollArea'),
      rootMargin: '0px',
      threshold: 1.0
    }

    let observer = new IntersectionObserver(callback, options);

    productBars.forEach(element => {


      observer.observe(element);
    });

    var buttons = document.querySelectorAll(".NutritionalValues--Toggle > .Link");
    buttons.forEach((element) => {
      element.addEventListener("click", (e) => {
        e.preventDefault();
        target = e.currentTarget.dataset.target;
        //document.querySelector(".NutritionalValues--Toggle > button.active").classList.add("active");
        document.querySelector(".NutritionalValues--Toggle > .Link.active").classList.remove("active");
        //e.currentTarget.classList.remove("active")
        e.currentTarget.classList.add("active")
        productBars.forEach(element => {
          var barStatus = element.querySelector(".SingleNutritional--BarStatus");
          var percent = (target == "m") ? barStatus.dataset.mPercent : barStatus.dataset.wPercent;
          barStatus.style.width = `${percent}%`
          var title = element.querySelector(".SingleNutritional--Title > span");
          title.innerText = `${percent}%`;
        });
      })
    });
  }




  if (document.getElementById('IngredientsCalculator--Select')) {
    document.getElementById('IngredientsCalculator--Select').addEventListener('change', function (e) {
      var count = e.target.value;
      var elements = document.querySelectorAll(".IngredientsCalculator--Table-Row[data-countable]");
      elements.forEach(function (element) {
        var value = parseFloat(element.dataset.value);
        var unit = element.dataset.unit;
        console.log(`${value} ${unit}`);
        element.querySelector(".IngredientsCalculator--Table-Value").innerText = `${value * count} ${unit}`;
      });
    });
  }
}

initPorductBars();




function get_params_from_href(href) {
  var paramstr = href.split('?')[1];        // get what's after '?' in the href
  var paramsarr = paramstr.split('&');      // get all key-value items
  var params = Array();
  for (var i = 0; i < paramsarr.length; i++) {
    var tmparr = paramsarr[i].split('='); // split key from value
    params[tmparr[0]] = tmparr[1];        // sort them in a arr[key] = value way
  }
  return params;
}


function add_cart_items_events(e) {
  var href = e.target.href;
  var action = e.target.dataset.action;
  var event;

  if (action == "remove-item") {
    event = "remove_from_cart";
  } else if (action == "update-item-quantity") {
    if (e.target.classList.contains('quantity-selector-decrease')) {
      event = "quantity_decreased";
    } else {
      event = "quantity_increased";
    }
  }
  var params = get_params_from_href(href);
  var parent = e.target.closest(".CartItem__Info");
  var productName = parent.querySelector('.CartItem__Title').textContent.trim();
  var productPrice = parent.querySelector('.CartItem__Price').textContent.trim();
  var productVariant = parent.querySelector('.CartItem__Variant').textContent.trim();
  var productQuantity = parent.querySelector('.QuantitySelector__CurrentQuantity').value;


  dataLayer.push({
    'event': event,
    'ecommerce': {
      'products': [{
        'name': productName,
        'id': parent.dataset.productSku,
        'price': productPrice,
        'brand': '',
        'category': '',
        'variant': productVariant,
        'list_name': '',
        'list': '',
        'handle': '',
        'shopifyId': params.id,
        'compare_at_price': '',
        'quantity': productQuantity
      }]
    }
  });
}

function init_cart_item_events() {
  var cart_items = document.querySelectorAll('.CartItem__Remove');
  for (let i = 0; i < cart_items.length; i++) {
    cart_items[i].addEventListener('click', add_cart_items_events)
  }

  var cart_items = document.querySelectorAll('.CartItem__QuantitySelector .QuantitySelector__Button');
  for (let i = 0; i < cart_items.length; i++) {
    cart_items[i].addEventListener('click', add_cart_items_events)
  }
}

init_cart_item_events();

document.addEventListener('theme:loading:end', function () {
  setTimeout(init_cart_item_events, 1000);
});


document.addEventListener('DOMContentLoaded', function () {

  var countrySelector = document.querySelector("#countrySelector");
  if (countrySelector) {
    countrySelector.addEventListener("change", function (e) {
      var input = document.querySelector('input[name="locale_code"], input[name="country_code"]')
      var form = document.querySelector("#localization_form");
      input.value = e.currentTarget.value;
      form.submit();
    });
  }

  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }

  function setWithExpiry(key, value) {
    const now = new Date()
    const ttl = 60 * 60 * 24;

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }

  var curentInterval = null;
  function startTimer(duration, display) {
    var timer = getWithExpiry('cartTimer'),
      minutes, seconds;
    curentInterval = setInterval(function () {
      var display = document.querySelector("#cartCountdown") || 1;

      minutes = parseInt(timer / 60, 10);
      seconds = parseInt(timer % 60, 10);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      if (display) {
        display.textContent = minutes + ":" + seconds;
      }
      setWithExpiry('cartTimer', timer);
      if (--timer < 0) {
        timer = duration;
        if (display) {
          document.querySelector('.cartCountdownAlert').style.display = 'none';
        }
        clearInterval(curentInterval)
      }

    }, 1000);
  }

  var tenMinutes = 60 * 10;
  var display = document.querySelector('#cartCountdown');
  var currentValue = getWithExpiry('cartTimer');

  if (display && (currentValue > 0 || currentValue === null)) {
    startTimer(tenMinutes, display);
  } else {
    if (document.querySelector('.cartCountdownAlert')) {
      document.querySelector('.cartCountdownAlert').style.display = 'none';
    }
  }

  var initTimer = function (e) {
    var display = document.querySelector('#cartCountdown');
    var currentValue = parseInt(getWithExpiry('cartTimer'));
    console.log(currentValue)
    if (!curentInterval && (currentValue > 0 || currentValue === null || isNaN(currentValue))) {
      setWithExpiry('cartTimer', tenMinutes);
      startTimer(tenMinutes, display);
    }
    if (currentValue == 0) {
      console.log("VALUE NULL");
      document.querySelector("#sidebar-cart").classList.add("hideAlert");
    }
  };

  document.addEventListener('product:added', function () {
    clearInterval(curentInterval)
    setWithExpiry('cartTimer', tenMinutes);
    startTimer(tenMinutes, display);
  });
  document.addEventListener('product:quantity:change', function () {
    console.log("product:quantity:change");
    clearInterval(curentInterval)
    setWithExpiry('cartTimer', tenMinutes);
    startTimer(tenMinutes, display);
  });
});



document.addEventListener('DOMContentLoaded', function () {




  function observeElement(element, property, callback, delay = 0) {
    let elementPrototype = Object.getPrototypeOf(element);
    if (elementPrototype.hasOwnProperty(property)) {
      let descriptor = Object.getOwnPropertyDescriptor(elementPrototype, property);
      Object.defineProperty(element, property, {
        get: function () {
          return descriptor.get.apply(this, arguments);
        },
        set: function () {
          let oldValue = this[property];
          descriptor.set.apply(this, arguments);
          let newValue = this[property];
          if (typeof callback == "function") {
            setTimeout(callback.bind(this, oldValue, newValue), delay);
          }
          return newValue;
        }
      });
    }
  }

  var mixAndMatchAtc = document.querySelector(".MixAndMatch--Collection #mixAndMatchATC");
  if (mixAndMatchAtc) {
    var totalElements = 0;
    var items = {};
    var quantitySelector = document.querySelectorAll(".QuantitySelector__CurrentQuantity");
    quantitySelector.forEach(elem => {
      console.log(elem);
      observeElement(elem, "value", function (oldValue, newValue) {
        var isAboPage = false;
        var packageSize, pricePerMeal;
        if (!document.querySelector(".MixAndMatch-Package.active")) {
          isAboPage = true;
        } else {
          packageSize = parseInt(document.querySelector(".MixAndMatch-Package.active").dataset.count);
          pricePerMeal = parseFloat(document.querySelector(".MixAndMatch-Package.active").dataset.priceMeal.replace(",", "."));
        }
        console.log(pricePerMeal);

        totalElements += (parseInt(newValue) - parseInt(oldValue));
        document.querySelector("#selectedProducts").innerText = totalElements;
        items[elem.dataset.sku] = parseInt(newValue);
        var totalPrice = Object.keys(items).reduce((value, item) => {
            const price  = document.querySelector(`input[data-sku='${item}']`).parentNode.parentNode.dataset.price; 
            const amount = items[item];
            return value+(price*amount);
          },0);
        
        if (isAboPage) {
          
          if (totalElements == 1) {
            document.querySelector(".severalMeals").style.display = 'none';
          } else {
            document.querySelector(".severalMeals").style.display = 'inline';
          }



          var totalPrice = Object.keys(items).reduce(function (previousValue, currentValue) {
            var item = document.querySelector(`[data-product-id='${currentValue}']`);
            var price = parseInt(item.dataset.price);
            var quantity = items[currentValue];
            return (price * quantity) + previousValue;
          }, 0)

          var discount = document.querySelector(".MixAndMatch-Overlay").dataset?.discount;
          if (!discount) {
            discount = 0.874843554443054;
          } else {
            discount = parseFloat(discount);
          }

          var minPrice = document.querySelector(".MixAndMatch-Overlay").dataset?.minPrice;
          if (minPrice) {
            minPrice = parseFloat(minPrice);

            if ((totalPrice*discount) >= minPrice) {
              mixAndMatchAtc.removeAttribute("disabled");
               if(location.pathname == '/collections/summerbody'){
                 mixAndMatchAtc.innerText = "Zur Kasse";
               }
            } else {
              mixAndMatchAtc.setAttribute("disabled", "disabled");
               if(location.pathname == '/collections/summerbody'){
                 if(location.hostname.endsWith(".ch")){
                   mixAndMatchAtc.innerText = "99 CHF Mindestbestellwert";                   
                 } else {
                   mixAndMatchAtc.innerText = "79 € Mindestbestellwert";
                 }
               }
            }
          } else {
            if (totalElements > 1) {
              mixAndMatchAtc.removeAttribute("disabled");
            } else {
              mixAndMatchAtc.setAttribute("disabled", "disabled");
            }
          }

          document.querySelector(".MixAndMatch-Overlay--Prices").style.display = 'flex';
          document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-ProductPrice").innerHTML = window.Shopify.formatMoney((totalPrice * discount));
          document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-ProductSubPrice").innerHTML = window.Shopify.formatMoney(totalPrice)
          return;
        }
        document.querySelector("#totalProducts").innerText = packageSize;

        //mixAndMatchAtc.querySelector("span").innerText = `Es fehlen noch ${packageSize-totalElements} Produkte`;
        if (totalElements > packageSize) {
          mixAndMatchAtc.setAttribute("disabled", "disabled");
        }
        document.querySelector("#totalProducts").style.display = 'inline';
        document.querySelector("#totalProductsDelimiter").style.display = 'inline';
        document.querySelector(".severalMeals").style.display = 'inline';

        if (totalElements > 0) {
          document.querySelector(".MixAndMatch-Overlay--Prices").style.display = 'flex';
        }

        var priceFaktor = 1;
        if (totalElements < packageSize) {
          mixAndMatchAtc.setAttribute("disabled", "disabled");
          document.querySelector(".CollectionMixAndMatch").classList.remove("disabled");
          if (packageSize == 12){
            priceFaktor = 0.95;
          } else if (packageSize == 18) {
            priceFaktor = 0.9
          }
        } else if (totalElements == packageSize && packageSize < 18) {
          mixAndMatchAtc.removeAttribute("disabled");
          document.querySelector(".CollectionMixAndMatch").classList.add("disabled");
          priceFaktor = 0.95;
        } else if (totalElements >= packageSize && totalElements >= 18 && packageSize == 18) {
          document.querySelector("#totalProducts").style.display = 'none';
          document.querySelector("#totalProductsDelimiter").style.display = 'none';
          document.querySelector(".severalMeals").style.display = 'none';
          mixAndMatchAtc.removeAttribute("disabled");
          priceFaktor = 0.90
        }

        var newPrice = ((totalPrice/100) * priceFaktor);
        document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-ProductPrice").innerHTML = `${window.Shopify.formatMoney(newPrice.toFixed(2))}€`
        document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-ProductSubPrice").innerHTML = `${window.Shopify.formatMoney((totalPrice/100).toFixed(2))}€`
        
        
      })
    });


    var popUpItems = document.querySelectorAll(".ProductItem__PopUp");
    popUpItems.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();

        fetch(e.currentTarget.href)
          .then(response => response.text())
          .then(data => {

            document.querySelector(".MixAndMatchProduct--Popup-Content").innerHTML = data;
            document.querySelector(".MixAndMatchProduct--Popup #addToBox").addEventListener("click", function (e) {
              e.preventDefault();
              var numberBox = document.querySelector(`[data-sku='${e.currentTarget.dataset.productId}']`)
              var productCount = parseInt(document.querySelector(".MixAndMatchProduct--Popup .QuantitySelector__CurrentQuantity").value);
              numberBox.value = (parseInt(numberBox.value) + productCount)
              document.querySelector(".MixAndMatchProduct--Popup").setAttribute('aria-hidden', 'true');
              document.querySelector(".MixAndMatchProduct--Popup-Content").innerHTML = '';
            });


            initPorductBars();


            var sku = document.querySelector(".MixAndMatchProduct--Popup-Content #reviews-sku").dataset.sku;
            new ReviewsWidget('.MixAndMatchProduct--Popup-Content #ReviewsWidget', {
              store: "www.loewenanteil.com",
              widget: "polaris",
              options: {
                types: "product_review, questions",
                lang: 'de',
                //Possible layout options: bordered, large and reverse.
                layout: '',
                //How many reviews & questions to show per page?
                per_page: 5,
                product_review: {
                  sku: sku,
                  hide_if_no_results: true


                },

                /* Toggle Options */
                questions: {
                  hide_if_no_results: false,
                  enable_ask_question: true,
                  show_dates: true,
                  grouping: "{{ product.variants | map: 'sku' | join: ';' }};{{ product.variants | map: 'id' | join: ';' }}"
                },

                //Header settings:
                header: {
                  enable_summary: true, //Show overall rating & review count
                  enable_ratings: true,
                  enable_attributes: false,
                  enable_image_gallery: false, //Show photo & video gallery
                  enable_percent_recommended: false, //Show what percentage of reviewers recommend it
                  enable_write_review: false, //Show "Write Review" button
                  enable_ask_question: true, //Show "Ask Question" button
                  enable_sub_header: true, //Show subheader
                },

                //Filtering settings:
                filtering: {
                  enable: true, //Show filtering options
                  enable_text_search: false, //Show search field
                  enable_sorting: true, //Show sorting options (most recent, most popular)
                  enable_overall_rating_filter: true, //Show overall rating breakdown filter
                  enable_ratings_filters: false, //Show product attributes filter
                  enable_attributes_filters: false, //Show author attributes filter
                },

                //Review settings:
                reviews: {
                  enable_avatar: false, //Show author avatar
                  enable_reviewer_name: true, //Show author name
                  enable_reviewer_address: false, //Show author location
                  reviewer_address_format: 'city, country', //Author location display format
                  enable_verified_badge: true, //Show "Verified Customer" badge
                  enable_reviewer_recommends: false, //Show "I recommend it" badge
                  enable_attributes: false, //Show author attributes
                  enable_product_name: false, //Show display product name
                  enable_review_title: false, //Show review title
                  enable_replies: undefined, //Show review replies
                  enable_images: false, //Show display review photos
                  enable_ratings: false, //Show product attributes (additional ratings)
                  enable_share: false, //Show share buttons
                  enable_helpful_vote: false, //Show "was this helpful?" section
                  enable_helpful_display: false, //Show how many times times review upvoted
                  enable_report: false, //Show report button
                  enable_date: true, //Show when review was published
                },
                text: {
                  "Verified Customer": "Verified Customer"
                },
              },

              translations: {
                'Verified Customer': 'Verifizierter Käufer'
              },
              /* Customise Colours & Fonts */
              styles: {
                //Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.
                '--base-font-size': '16px',

                //Button styles (shared between buttons):
                '--common-button-font-family': 'inherit',
                '--common-button-font-size': '16px',
                '--common-button-font-weight': '500',
                '--common-button-letter-spacing': '0',
                '--common-button-text-transform': 'none',
                '--common-button-vertical-padding': '10px',
                '--common-button-horizontal-padding': '20px',
                '--common-button-border-width': '2px',
                '--common-button-border-radius': '0px',

                //Primary button styles:
                '--primary-button-bg-color': '#0E1311',
                '--primary-button-border-color': '#0E1311',
                '--primary-button-text-color': '#ffffff',

                //Secondary button styles:
                '--secondary-button-bg-color': 'transparent',
                '--secondary-button-border-color': '#0E1311',
                '--secondary-button-text-color': '#0E1311',

                //Star styles:
                '--common-star-color': '#fbcd0a',
                '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
                '--medium-star-size': '22px',
                '--small-star-size': '19px',

                //Heading styles:
                '--heading-text-color': '#0E1311',
                '--heading-text-font-weight': '600',
                '--heading-text-font-family': 'inherit',
                '--heading-text-line-height': '1.4',
                '--heading-text-letter-spacing': '0',
                '--heading-text-transform': 'none',

                //Body text styles:
                '--body-text-color': '#0E1311',
                '--body-text-font-weight': '400',
                '--body-text-font-family': 'inherit',
                '--body-text-line-height': '1.4',
                '--body-text-letter-spacing': '0',
                '--body-text-transform': 'none',

                //Input field styles:
                '--inputfield-text-font-family': 'inherit',
                '--input-text-font-size': '14px',
                '--inputfield-text-font-weight': '400',
                '--inputfield-text-color': '#0E1311',
                '--inputfield-border-color': 'rgba(0,0,0,0.2)',
                '--inputfield-background-color': 'transparent',
                '--inputfield-border-width': '1px',
                '--inputfield-border-radius': '0px',

                '--common-border-color': 'rgba(0,0,0,0.15)',
                '--common-border-width': '1px',
                '--common-sidebar-width': '190px',

                //Slider indicator (for attributes) styles:
                '--slider-indicator-bg-color': 'rgba(0,0,0,0.1)',
                '--slider-indicator-button-color': '#0E1311',
                '--slider-indicator-width': '190px',

                //Badge styles:
                '--badge-icon-color': '#0E1311',
                '--badge-icon-font-size': 'inherit',
                '--badge-text-color': '#0E1311',
                '--badge-text-font-size': 'inherit',
                '--badge-text-letter-spacing': 'inherit',
                '--badge-text-transform': 'inherit',

                //Author styles:
                '--author-font-size': 'inherit',
                '--author-text-transform': 'none',

                //Author avatar styles:
                '--avatar-thumbnail-size': '60px',
                '--avatar-thumbnail-border-radius': '100px',
                '--avatar-thumbnail-text-color': '#0E1311',
                '--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',

                //Product photo or review photo styles:
                '--photo-video-thumbnail-size': '80px',
                '--photo-video-thumbnail-border-radius': '0px',

                //Media (photo & video) slider styles:
                '--mediaslider-scroll-button-icon-color': '#0E1311',
                '--mediaslider-scroll-button-bg-color': 'rgba(255, 255, 255, 0.85)',
                '--mediaslider-overlay-text-color': '#ffffff',
                '--mediaslider-overlay-bg-color': 'rgba(0, 0, 0, 0.8))',
                '--mediaslider-item-size': '110px',

                //Pagination & tabs styles (normal):
                '--pagination-tab-text-color': '#0E1311',
                '--pagination-tab-text-transform': 'none',
                '--pagination-tab-text-letter-spacing': '0',
                '--pagination-tab-text-font-size': '16px',
                '--pagination-tab-text-font-weight': '600',

                //Pagination & tabs styles (active):
                '--pagination-tab-active-text-color': '#0E1311',
                '--pagination-tab-active-text-font-weight': '600',
                '--pagination-tab-active-border-color': '#0E1311',
                '--pagination-tab-border-width': '3px',
              },

            });

            new window.Flickity(document.querySelector(".MixAndMatchProduct--Popup-Content .Product__Slideshow"), { wrapAround: false, pageDots: true, cellAlign: 'left', prevNextButtons: false });
            ratingSnippet("MixAndMatchProduct--Popup-Content .ruk_rating_snippet", { store: "www.loewenanteil.com", color: "#fbcd0a", linebreak: true, snippetPopup: false })
            initDecreaseAndIncreaseEvents(".MixAndMatchProduct--Popup");

            document.querySelector(".MixAndMatchProduct--Popup .NewsletterPopup__Close").addEventListener("click", function (e) {
              e.preventDefault();
              document.querySelector(".MixAndMatchProduct--Popup").setAttribute('aria-hidden', 'true');
              document.querySelector(".MixAndMatchProduct--Popup-Content").innerHTML = '';
            });
          });
        document.querySelector(".MixAndMatchProduct--Popup").setAttribute('aria-hidden', 'false');

      });
    });

    function initDecreaseAndIncreaseEvents(selector) {
      var quantityDecrease = document.querySelectorAll(`${selector} [data-action="decrease-quantity-null"]`);
      quantityDecrease.forEach(elem => {
        elem.addEventListener("click", function (e) {
          e.preventDefault();
          var quantityField = e.currentTarget.parentNode.querySelector(".QuantitySelector__CurrentQuantity");
          var value = Math.max(parseInt(quantityField.value) - 1, 0);
          quantityField.value = value;

          const productId = e.currentTarget.closest(".ProductItem").dataset.productId
          let data = sessionStorage.getItem("abo_selection");
          if(!data){
            data = {}
          } else {
            data = JSON.parse(data);
          }
          data[e.currentTarget.closest(".ProductItem").dataset.productId] = value;
          sessionStorage.setItem("abo_selection", JSON.stringify(data));
        });
      });

      var quantityIncrease = document.querySelectorAll(`${selector} [data-action="increase-quantity"]`);
      quantityIncrease.forEach(elem => {
        elem.addEventListener("click", function (e) {
          e.preventDefault();
          var quantityField = e.currentTarget.parentNode.querySelector(".QuantitySelector__CurrentQuantity");
          var value = parseInt(quantityField.value) + 1;
          quantityField.value = value;

          const productId = e.currentTarget.closest(".ProductItem").dataset.productId
          let data = sessionStorage.getItem("abo_selection");
          if(!data){
            data = {}
          } else {
            data = JSON.parse(data);
          }
          data[e.currentTarget.closest(".ProductItem").dataset.productId] = value;
          sessionStorage.setItem("abo_selection", JSON.stringify(data));
        });
      });
    }
    initDecreaseAndIncreaseEvents("");

    var packages = document.querySelectorAll(".MixAndMatch-Package");
    if (packages && packages.length) {
      packages.forEach(elem => {
        elem.addEventListener("click", function (e) {
          e.preventDefault();
          if (e.currentTarget.classList.contains("active")) return;
          document.querySelector(".MixAndMatch-Package.active").classList.remove("active");
          e.currentTarget.classList.add("active");
          document.querySelector(".CollectionMixAndMatch").classList.remove("disabled");
          document.querySelector("#totalProducts").innerText = e.currentTarget.dataset.count;
          document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-ProductPrice").innerHTML = e.currentTarget.querySelector(".MixAndMatch-ProductPrice").innerHTML;
          if (e.currentTarget.dataset.count <= 6) {
            document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-ProductSubPrice").style.display = 'none';
            document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-SavingATC").style.display = 'none';
          } else {
            document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-ProductSubPrice").style.display = 'inline';
            document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-SavingATC").style.display = 'flex';
            document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-ProductSubPrice").innerHTML = e.currentTarget.querySelector(".MixAndMatch-ProductSubPrice").innerHTML;
            document.querySelector(".MixAndMatch-Overlay--Prices .MixAndMatch-SavingATC").innerHTML = e.currentTarget.querySelector(".MixAndMatch-Saving").innerHTML;
          }

          if (totalElements == e.currentTarget.dataset.count) {
            mixAndMatchAtc.removeAttribute("disabled");
          } else if (totalElements > e.currentTarget.dataset.count) {
            mixAndMatchAtc.setAttribute("disabled", "disabled");
            document.querySelector(".CollectionMixAndMatch").classList.add("disabled");
            if (e.currentTarget.dataset.count < 18) {
              document.querySelector("#totalProducts").style.display = 'inline';
              document.querySelector("#totalProductsDelimiter").style.display = 'inline';
              document.querySelector(".severalMeals").style.display = 'inline';
            }

          } else {
            mixAndMatchAtc.setAttribute("disabled", "disabled");
          }
        })
      });
    }

    if(location.pathname == '/collections/summerbody'){
        let data = sessionStorage.getItem("abo_selection");
        if(data){
          data = JSON.parse(data);
          Object.keys(data).forEach(item => {
            var productItem = document.querySelector(`.ProductItem[data-product-id='${item}'] input`);
            productItem.value = data[item];
          });
        }
    }
    
    mixAndMatchAtc.addEventListener("click", function (e) {
      var cartItems = [];
      var isAbo = false;
      if (!document.querySelector(".MixAndMatch-Package.active")) {
        Object.keys(items).forEach(item => {
          var sellingPlan = document.querySelector(`[data-product-id='${item}']`).dataset.sellingPlan;
            if(!!sellingPlan){
              isAbo = true;
            }
          cartItems.push({
            id: item,
            selling_plan: sellingPlan,
            quantity: items[item]
          });
        });

      } else {
        Object.keys(items).forEach(item => {
          cartItems.push({
            id: item,
            quantity: items[item],
            properties: {
              '_is_mixandmatch': true
            }
          });
        });
      }

      if(isAbo){
      fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        fetch('/cart/add.js', {
          method: 'POST', // or 'PUT'
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: cartItems }),
        }).then(res => res.json())
          .then(res => {
            console.log(res);
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            if(location.pathname == '/collections/summerbody'){
              window.location.href = '/checkout';
              return;
            }
            
            res.items.forEach(item => {
              document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: item.variant_id,
                  quantity: item.quantity,
                },
              }));

            })
            //window.location = `/discount/mixmatch12?redirect=/checkout`;
          });
      });

      } else {

      let updates = {
        'id': "39535174582346",
        'quantity': 0
      }
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => {
        fetch('/cart/add.js', {
          method: 'POST', // or 'PUT'
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: cartItems }),
        }).then(res => res.json())
          .then(res => {
            console.log(res);
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            res.items.forEach(item => {
              document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: item.variant_id,
                  quantity: item.quantity,
                },
              }));

            })
            //window.location = `/discount/mixmatch12?redirect=/checkout`;
          });
      });

      }
      console.log(items);
    });

    document.querySelector(".MixAndMatchProduct--Popup").addEventListener("click", function (e) {
      if (e.target.classList.contains("MixAndMatchProduct--Popup")) {
        document.querySelector(".MixAndMatchProduct--Popup").setAttribute('aria-hidden', 'true');
        document.querySelector(".MixAndMatchProduct--Popup-Content").innerHTML = '';
      }

    });
  }

  if (!mixAndMatchAtc) {
    console.log("PDP MIX AND MATCH");
    mixAndMatchAtc = document.querySelector(".MixAndMatch--Product #mixAndMatchATC");
    console.log(mixAndMatchAtc);
    if (mixAndMatchAtc) {
      var totalElements = 0;
      var items = {};
      
      var quantitySelector = document.querySelectorAll(".QuantitySelector__CurrentQuantity");
      quantitySelector.forEach(elem => {
        observeElement(elem, "value", function (oldValue, newValue) {
          var packageSize = document.querySelector(".MixAndMatch-Package.active").dataset.count;
          totalElements += (parseInt(newValue) - parseInt(oldValue));
          mixAndMatchAtc.querySelector("span").innerText = `Es fehlen noch ${packageSize - totalElements} Produkte`;
          if (totalElements > packageSize) {
            mixAndMatchAtc.querySelector("span").innerText = `Entferne ${totalElements - packageSize} Produkte`;
          }
          items[elem.dataset.sku] = parseInt(newValue);
          if (totalElements < packageSize) {
            mixAndMatchAtc.setAttribute("disabled", "disabled");
            document.querySelector(".MixAndMatch-ProductContainer").classList.remove("disabled");
          } else if (totalElements == packageSize) {
            mixAndMatchAtc.removeAttribute("disabled");
            mixAndMatchAtc.querySelector("span").innerText = "In den Warenkorb";
            document.querySelector(".MixAndMatch-ProductContainer").classList.add("disabled");
          }

          var totalPrice = Object.keys(items).reduce((value, item) => {
            const price  = document.querySelector(`input[data-sku='${item}']`).dataset.price; 
            const amount = items[item];
            return value+(price*amount);
          },0);
          
          const currentCount = document.querySelector(".MixAndMatch-Package.active").dataset.count;
          console.log(currentCount);

          if(currentCount == "12"){
            const minPrice = Math.min(...Array.from(document.querySelectorAll(".MixAndMatch-ProductContainer .QuantitySelector__CurrentQuantity")).filter(item => item.value > 0).map(item => parseInt(item.dataset.price)));
            document.querySelector("#mixAndMatchPriceSale").style.display = 'inline';
            document.querySelector("#mixAndMatchPriceSale").innerHTML = window.Shopify.formatMoney(totalPrice);
            totalPrice = totalPrice * 0.95;
          } else if(currentCount == "18") {
            document.querySelector("#mixAndMatchPriceSale").style.display = 'inline';
            document.querySelector("#mixAndMatchPriceSale").innerHTML = window.Shopify.formatMoney(totalPrice);

            totalPrice = totalPrice * 0.9;
          }

          document.querySelector("#mixAndMatchPrice").innerHTML = window.Shopify.formatMoney((isFinite(totalPrice)) ? totalPrice : 0);
       
        })
        
      });


      var packages = document.querySelectorAll(".MixAndMatch-Package");
      if (packages && packages.length) {
        packages.forEach(elem => {
          elem.addEventListener("click", function (e) {
            e.preventDefault();
            if (e.currentTarget.classList.contains("active")) return;
            if(e.currentTarget.dataset.count == "6"){
              document.querySelector("#mixAndMatchPriceSale").style.display = 'none';
            }
            document.querySelector("#mixAndMatchPrice").innerHTML = `ab ${window.Shopify.formatMoney(e.currentTarget.dataset.priceFrom)}`;
           
            document.querySelector(".MixAndMatch-Package.active").classList.remove("active");
            e.currentTarget.classList.add("active");
            document.querySelector(".MixAndMatch-ProductContainer").classList.remove("disabled");

            mixAndMatchAtc.querySelector("span").innerText = `Es fehlen noch ${e.currentTarget.dataset.count - totalElements} Produkte`;
            if(!Object.keys(items).length){
              document.querySelector("#mixAndMatchPrice").innerHTML = `ab ${window.Shopify.formatMoney(e.currentTarget.dataset.priceFrom)}`;
            }
            
            if (totalElements == e.currentTarget.dataset.count) {
              mixAndMatchAtc.removeAttribute("disabled");
              mixAndMatchAtc.querySelector("span").innerText = "In den Warenkorb";
            } else if (totalElements > e.currentTarget.dataset.count) {
              document.querySelector(".MixAndMatch-ProductContainer").classList.add("disabled");
              mixAndMatchAtc.setAttribute("disabled", "disabled");
              mixAndMatchAtc.querySelector("span").innerText = `Entferne ${totalElements - e.currentTarget.dataset.count} Produkte`;
            } else {
              mixAndMatchAtc.setAttribute("disabled", "disabled");
            }
          })
        });
      }

      mixAndMatchAtc.addEventListener("click", function (e) {
        var cartItems = [];
        Object.keys(items).forEach(item => {
          cartItems.push({
            id: item,
            quantity: items[item],
            properties: {
              '_is_mixandmatch': true
            }
          });
        });


        let updates = {
          'id': "39535174582346",
          'quantity': 0
        }
        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(updates)
        })
        .then(response => {
          fetch('/cart/add.js', {
            method: 'POST', // or 'PUT'
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: cartItems }),
          }).then(res => res.json())
            .then(res => {
              console.log(res);
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              res.items.forEach(item => {
                document.dispatchEvent(new CustomEvent('product:added', {
                  bubbles: true,
                  detail: {
                    variant: item.variant_id,
                    quantity: item.quantity
                  },
                }));

              })
              //window.location = `/discount/mixmatch12?redirect=/checkout`;
            });
        });



        console.log(items);
      });


    }
  }
});

function quickAddUpsell(event) {
  document.dispatchEvent(new CustomEvent('theme:loading:start'));

  const variantId = event.currentTarget.dataset.variantId;
  let formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };

  fetch(window.theme.localeRootUrl + '/cart/add.js', {
    body: JSON.stringify(formData),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest', 
    },
  })
  .then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.dispatchEvent(
      new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variantId,
          quantity: 1,
        },
      })
    );
  })
  .catch(function (error) {
    console.error('Error adding product:', error);
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
}

var cartUpsellSliders = document.getElementsByClassName('Upsell__Slider');
  if (cartUpsellSliders && cartUpsellSliders.length) {
    for (var i = 0; i < cartUpsellSliders.length; i++) {
      var flickityConfig = JSON.parse(cartUpsellSliders[i].dataset.flickityConfig);
      flickityConfig.dragThreshold = 0;
      flickityConfig.touchEnabled = true;

      new window.Flickity(cartUpsellSliders[i], flickityConfig);
    }
    const upsellCells = document.querySelectorAll('.Upsell_Cell-info h2');
    
    let maxHeight = 0;
    upsellCells.forEach(cell => {
        const cellHeight = cell.offsetHeight;
        if (cellHeight > maxHeight) {
            maxHeight = cellHeight;
        }
    });
    upsellCells.forEach(cell => {
        cell.style.height = `${maxHeight}px`;
    });
  }

function initializeCartUpsellSlider() {
  var cartUpsellSliders = document.getElementsByClassName('Upsell__Slider');
  if (cartUpsellSliders && cartUpsellSliders.length) {
    for (var i = 0; i < cartUpsellSliders.length; i++) {
      var flickityConfig = JSON.parse(cartUpsellSliders[i].dataset.flickityConfig);
      flickityConfig.dragThreshold = 0; 
      flickityConfig.touchEnabled = true;

      new window.Flickity(cartUpsellSliders[i], flickityConfig);
    }
  }
  const upsellCells = document.querySelectorAll('.Upsell_Slider-mobile .Upsell_Cell-info h2');
    
    let maxHeight = 0;
    upsellCells.forEach(cell => {
        const cellHeight = cell.offsetHeight;
        if (cellHeight > maxHeight) {
            maxHeight = cellHeight;
        }
    });
    upsellCells.forEach(cell => {
        cell.style.height = `${maxHeight}px`;
    });
}

function addTimeouts() {
  initializeCartUpsellSlider();
  requestAnimationFrame(() => initializeCartUpsellSlider());
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 10);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 30);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 50);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 100);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 150);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 200);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 250);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 300);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 350);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 400);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 500);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 600);
  setTimeout(() => requestAnimationFrame(() => initializeCartUpsellSlider()), 900);
}

['product:added', 'product:changed', 'variant:changed', 'cart:refresh', 'theme:loading:end', 'product:quantity:change'].forEach(function(eventName) {
  document.addEventListener(eventName, addTimeouts);
});

function copyThisText(element) {
  var copyText = element.querySelector('span').innerText;
  navigator.clipboard.writeText(copyText).then(() => {
    console.log(copyText);
    var tooltip = element.querySelector('.discount-tooltip');
    tooltip.classList.add('discount-tooltip-is-active');
    
    setTimeout(() => {
      tooltip.classList.remove('discount-tooltip-is-active');
    }, 1000);
  }).catch(err => {
    console.error('Failed to copy text: ', err);
  });
}

document.addEventListener('variant:changed', function(event) {
  const productForm = document.querySelector('.Product');
  if (productForm && productForm.contains(event.target)) {
      var getPrice = event.detail.variant.price;
      var formatedPrice = window.Shopify.formatMoney(getPrice);
      var getDiscount = parseInt(document.querySelector('.ProductForm__DiscountBox').getAttribute('data-discount'));
      var updatedPrice = getPrice - getPrice * getDiscount * 0.01;
      var formattedUptadedPrice = window.Shopify.formatMoney(updatedPrice);
      document.querySelector('.ProductForm__DiscountBox--discounted-price').textContent = formattedUptadedPrice;
      document.querySelector('.ProductForm__DiscountBox--price').textContent = formatedPrice;
  }
});